import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const EmptyView = ({ error, loading, media, showName }) => {
  const exist = !isEmpty(media);
  const { processed } = media;

  function getContent() {
    if (loading) {
      return <CircularProgress />;
    }

    if (error) {
      return (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      );
    }

    if (!processed) {
      return (
        <Box textAlign="center">
          <Typography color="secondary" variant="body1">
            <FormattedMessage id="media.processing" />
          </Typography>
          {showName && (
            <Typography color="secondary" variant="body1">
              {media.name}
            </Typography>
          )}
        </Box>
      );
    }

    if (!exist || media?.sources?.length === 0) {
      return (
        <Typography color="error" variant="body2">
          <FormattedMessage id="video.notFound" defaultMessage="No se encontró el video" />
        </Typography>
      );
    }

    return null;
  }

  const content = getContent();

  if (!content) return null;

  return (
    <Box width="100%" bgcolor="grey.100" pt="56.25%" position="relative">
      <Box display="flex" alignItems="center" justifyContent="center" position="absolute" width="100%" height="100%" top={0} left={0}>
        {content}
      </Box>
    </Box>
  );
};

EmptyView.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  media: PropTypes.object,
  showName: PropTypes.bool,
};

EmptyView.defaultProps = {
  error: undefined,
  loading: false,
  showName: false,
  media: {},
};

export default EmptyView;
